export default {
  agents: (state) => state.agents || [],
};
